import TimelineTitledTabTabsConfig from "./timeline-titled-tab-tabs-config";
import TimelineTitledTabTabsAdvancedConfig from "./timeline-titled-tab-tabs-advanced-config";
import dynamic from "next/dynamic";
const TimelineTitledTabTabsComponent = dynamic(()=>import("./timeline-titled-tab-tabs-component"));
export default {
    TimelineTitledTabTabsComponent,
    TimelineTitledTabTabsConfig,
    TimelineTitledTabTabsAdvancedConfig
};
